module.exports = __webpack_public_path__ + "img/finance4.c1972f81.png";